export default __webpack_public_path__ + "static/media/item3.8dd65438.jpeg";